<script>
import formatDate from '@utils/format-date'
import formatServiceTime from "@utils/format-service-time";
import formatCurrency from "@utils/format-currency";

export default {
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    formatDate,
    formatServiceTime,
    formatCurrency,
    getDefaultImage(images) {
      const defaultImageItems = images.filter(image => image.default) || [];

      return defaultImageItems[0]?.path || ''
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.depositItemSectionItemInfoBox">
    <div class="row">
      <div class="col-md-12 depositItemSectionItemInfoBox__infoBoxContent">
        <div>
          <div class="depositItemSectionItemInfoBox__title">
            {{ orderItem.deposit.title || '自訂方案' }}
          </div>
          <div class="depositItemSectionItemInfoBox__meta">
            {{ formatCurrency(orderItem.deposit.point) }}點儲值金
          </div>
        </div>
        <div v-if="orderItem.deposit.description" class="depositItemSectionItemInfoBox__info mt-3">
          {{ orderItem.deposit.description }}
        </div>
      </div>
    </div>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.depositItemSectionItemInfoBox {
  padding: 1rem;
  margin-bottom: 2rem;
  background: rgba($color-gray-4, 0.2);

  @include max-md {
    padding: 0;
    border-radius: 12px;
  }

  a {
    color: $color-gray-2;
    transition: color 0.3s;

    &:hover {
      color: $color-primary;
    }
  }

  :global {
    .depositItemSectionItemInfoBox {
      &__infoBoxContent {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;

        @include max-md {
          padding-top: 1rem;
          padding-right: 35px;
          padding-bottom: 1rem;
          padding-left: 35px;
        }
      }

      &__title {
        margin-bottom: 0.25rem;
        font-size: 1.125rem;
        font-weight: 600;

        @include max-md {
          font-size: 0.875rem;
          color: $color-blue-dark;
        }
      }

      &__meta {
        font-size: 1rem;
        color: $color-primary;

        @include max-md {
          margin-bottom: 1rem;
          font-size: .875rem;
        }
      }

      &__info {
        font-size: 1rem;
        line-height: 1.75;
        color: $color-gray-2;

        @include max-xl {
          font-size: .875rem;
        }
      }
    }
  }
}
</style>
